<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="mx-2"
              color="primary"
              v-if="!listFlag"
              @click="createItem"
            >
              「新規登録」はこのボタンを押してください
            </v-btn>
          </template>
        </v-dialog>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0">
          防災関係者向け広報管理は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <v-col cols="6" md="3">
            <v-select
              v-model="disasterNameFilterValue"
              :items="disasters"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="災害名称"
              item-text="disaster_name"
              item-value="disaster_no"
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="orderStatusFilterValue"
              :items="orderStatus"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="配信状況"
              multiple
              clearable
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="emergencyClassFilterValue"
              :items="emergencyClass"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="緊急事態区分"
              item-text="name"
              item-value="emergencyClass"
              clearable
              outlined
            >
              <template v-slot:selection="data">
                {{ emergencyClassItems(data.item) }}
              </template>
              <template v-slot:item="data">
                {{ emergencyClassItems(data.item) }}
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              v-model="municipCodeFilterList"
              :items="municipalities"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="市町村"
              item-text="municip_name"
              item-value="municip_code"
              clearable
              outlined
              multiple
              @change="changeMunicipality"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              v-model="organizeIdFilterList"
              :items="organizations"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="組織名"
              item-text="organize_name"
              item-value="organize_id"
              clearable
              outlined
              multiple
            >
            </v-select>
          </v-col>
        </v-row>
        <datetime-picker
          :title="'配信日時（開始）'"
          :without-now="true"
          :max="endDateValue"
          :selectedDatetime.sync="startDateValue"
        />
        <datetime-picker
          :title="'配信日時（終了）'"
          :without-now="true"
          :min="startDateValue"
          :selectedDatetime.sync="endDateValue"
        />
        <v-divider class="mb-1" />
      </v-container>
      <top-operation-data-table
        :headers="headers"
        :items="disasterDeliverys"
        :sort-by="['delivery_date']"
        :sort-desc="true"
        ref="disasterDeliveryTable"
        class="fixedWidth"
        disp-mode="nowrap"
        locale="ja-jp"
        loading-text="読込中"
        must-sort
      >
        <template v-slot:[`item.delivery_date`]="{ item }">
          {{ formatDatetime(item.delivery_date) }}
        </template>
        <template v-slot:[`item.delivery_status`]="{ item }">
          <template v-if="item.delivery_status === '0'">未配信</template>
          <template v-if="item.delivery_status === '1'">配信中</template>
          <template v-if="item.delivery_status === '2'">配信済</template>
          <template v-if="item.delivery_status === '3'">配信失敗</template>
        </template>
        <template v-slot:[`item.emerg_cls`]="{ item }">
          <template v-if="item.emerg_cls === 'AL'">ＡＬ：警戒事態</template>
          <template v-if="item.emerg_cls === 'SE'">
            ＳＥ：施設敷地緊急事態
          </template>
          <template v-if="item.emerg_cls === 'GE'">
            ＧＥ：全面緊急事態
          </template>
          <template v-if="item.emerg_cls === 'FN'"> 終結 </template>
        </template>
        <template v-slot:[`item.delivery_body`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="d-inline-block text-truncate"
                style="max-width: 720px"
              >
                {{ item.delivery_body }}
              </span>
            </template>
            <span>{{ item.delivery_body }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div v-if="listFlag">
            <v-btn small class="mx-2" color="primary" @click="viewItem(item)">
              参照
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              small
              class="mx-2"
              color="primary"
              @click="editItem(item)"
              v-if="
                item.delivery_status == '0' && hasUpdateAuthorityByItem(item)
              "
            >
              編集
            </v-btn>
            <v-btn small class="mx-2" color="primary" @click="viewItem(item)">
              参照
            </v-btn>
            <v-btn
              small
              class="mx-2"
              color="primary"
              @click="deleteItem(item)"
              v-if="
                ['0', '3'].includes(item.delivery_status) &&
                  hasDeleteAuthorityByItem(item)
              "
            >
              削除
            </v-btn>
          </div>
        </template>
      </top-operation-data-table>
      <v-row>
        <v-col cols="12">
          <div class="d-flex">
            <v-btn color="primary" @click="reload"> 最新の情報に更新 </v-btn>
            <div class="mt-2 ml-1 caption">※最新の情報に更新します。</div>
          </div>
        </v-col>
      </v-row>
    </v-sheet>
    <confirm-dialog ref="confirm" />
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Vue from "vue";
import orderBy from "lodash/orderBy";
import Disaster from "@/plugins/disaster";
import messageUtils from "@/mixins/message-utils";
import config from "@/js/const";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { DisasterTranslator } from "@/js/translators/disasterTranslator";
import { ScreenId } from "@/js/value-objects/screen-id";
import { ScreenCrud } from "@/js/value-objects/screen-crud";
import { EmergencyClass } from "@/js/value-objects/emergency-class";

const allAreaRepository = RepositoryFactory.get("allArea");
const disasterInfoRepository = RepositoryFactory.get("disasterInfo");
const deliveryRepository = RepositoryFactory.get("disasterStaffDelivery");
const organizeMstRepository = RepositoryFactory.get("organizeMst");

Vue.use(Disaster);
export default {
  mixins: [messageUtils],
  components: {
    DatetimePicker: () => import("@/components/DatetimePicker"),
    ConfirmDialog: () => import("@/components/ConfirmDialog"),
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    screenId: ScreenId.SF1801,
    config: config,
    overlay: false,
    dialog: false,
    listFlag: false,
    disasters: [],
    disasterDeliverys: [],
    municipalities: [],
    emergencyClass: EmergencyClass.listAll(),
    baseOrganizations: [],
    organizations: [],
    startDateValue: "",
    endDateValue: "",
    disasterNameFilterValue: "",
    emergencyClassFilterValue: "",
    orderStatusFilterValue: "",
    municipCodeFilterList: [],
    organizeIdFilterList: []
  }),

  mounted() {
    this.pageTitle(this.screenTitle);
  },

  created() {
    this.initialize();
  },

  computed: {
    screenTitle() {
      if (this.listFlag) {
        return ScreenId.getScreenTitle(this.screenId) + "（参照）";
      } else {
        return ScreenId.getScreenTitle(this.screenId) + "（登録・編集・削除）";
      }
    },

    headers() {
      return [
        {
          text: "配信日時",
          value: "delivery_date",
          filter: this.registrationDateFilter
        },
        {
          text: "災害ID",
          value: "disaster_no",
          align: " d-none",
          filter: this.disasterNameFilter
        },
        {
          text: "市町村コード",
          value: "dest.municip_codes",
          align: " d-none",
          filter: this.municipCodeFilter
        },
        {
          text: "組織ID",
          value: "dest.organize_ids",
          align: " d-none",
          filter: this.organizeIdFilter
        },
        {
          text: "災害名称",
          value: "disaster_name"
        },
        {
          text: "緊急事態区分",
          value: "emerg_cls",
          filter: this.emergencyClassFilter,
          sort: this.emergencyClassSorter
        },
        {
          text: "スマホアプリ（プッシュ通知）",
          value: "delivery_status",
          filter: this.orderStatusFilter
        },
        {
          text: "広報内容",
          value: "delivery_body"
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    },

    orderStatus() {
      return [
        {
          value: "0",
          text: "未配信"
        },
        {
          value: "1",
          text: "配信中"
        },
        {
          value: "2",
          text: "配信済"
        },
        {
          value: "3",
          text: "配信失敗"
        }
      ];
    },

    displayStartDateValue: {
      get: function() {
        return this.formatDate(this.startDateValue);
      },
      set: function() {}
    },

    displayEndDateValue: {
      get: function() {
        return this.formatDate(this.endDateValue);
      },
      set: function() {}
    },

    formatDate: function() {
      return function(date) {
        return date ? this.$moment(date).format("YYYY/MM/DD") : "";
      };
    }
  },

  watch: {
    $route: "initialize"
  },

  methods: {
    async initialize() {
      this.overlay = true;
      const data = this.$screenAuthority.find(auth => {
        const screenCrud = ScreenCrud.factory(auth.screen_crud);
        return auth.screen_id === this.screenId && screenCrud.isOperation();
      });
      if (!data) {
        this.listFlag = true;
      }

      await Promise.all([
        // 災害情報
        disasterInfoRepository.list(this.screenId),
        // 市町村一覧
        allAreaRepository.getAllArea(),
        // 組織情報
        organizeMstRepository.list(this.screenId),
        // 防災関係者向け広報一覧
        deliveryRepository.list(this.screenId)
      ])
        .then(values => {
          // 災害情報
          this.disasters = DisasterTranslator.sortByDisasterNo(
            values[0].data.results,
            true
          );
          // 市町村一覧
          this.municipalities = values[1].data.results[0].municipalities
            .concat(values[1].data.results[1].municipalities)
            .filter(m => m.disp_flg !== "1");
          // 組織情報一覧
          this.baseOrganizations = orderBy(values[2].data.results, ["disp_no"]);
          // 防災関係者向け広報
          this.disasterDeliverys = values[3].data.results;
          // 災害名称の初期値設定
          this.disasterNameFilterValue = this.$disaster.disaster_no;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "aggregation-menu");
        });

      this.overlay = false;
    },

    changeMunicipality(value) {
      // 現在の検索項目の組織を消去
      this.organizeIdFilterList = [];
      // 組織の一覧を変更
      this.organizations = this.baseOrganizations.filter(organization =>
        value.includes(organization.municip_code)
      );
    },

    createItem() {
      this.$router.push({
        name: "manager-order-create"
      });
    },

    editItem(item) {
      this.$router.push({
        name: "manager-order-edit",
        params: {
          item: item
        }
      });
    },

    viewItem(item) {
      this.$router.push({
        name: "manager-order-view",
        params: {
          item: item
        }
      });
    },

    async deleteItem(item) {
      let message = "この広報内容を削除してもよろしいですか？";
      if (!(await this.deleteConfirm(message))) {
        return false;
      }
      message = "削除した場合には元に戻せません。本当によろしいですか？";
      if (!(await this.deleteConfirm(message))) {
        return false;
      }
      // 削除
      const payload = {
        delivery_no: item.delivery_no,
        hash: item.hash
      };

      this.clearMessage();
      await deliveryRepository
        .delete(this.screenId, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        });

      // 一覧取得
      this.overlay = true;
      await deliveryRepository
        .list(this.screenId)
        .then(response => {
          this.disasterDeliverys = response.data.results;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "aggregation-menu");
        });
      this.overlay = false;
    },

    deleteConfirm(message) {
      return this.$refs.confirm.open(message, "削除");
    },

    formatDatetime(datetime) {
      if (!datetime) {
        return "";
      }
      const formattedDatetime = this.$moment(datetime, "YYYYMMDDHHmmss");
      if (!formattedDatetime.isValid()) {
        return "";
      }
      return formattedDatetime.format("YYYY/MM/DD HH:mm");
    },

    emergencyClassItems(item) {
      const EMERGENCY_NAME = EmergencyClass.factory(
        item.emergencyClass
      ).toName();
      return EMERGENCY_NAME ? EMERGENCY_NAME : "緊急事態区分なし";
    },

    registrationDateFilter(value) {
      this.resetPage();
      if (!this.startDateValue && !this.endDateValue) {
        return true;
      }
      const formattedStartDate = this.$moment(
        this.startDateValue,
        "YYYY/MM/DD HH:mm:ss"
      );
      const formattedendDate = this.$moment(
        this.endDateValue,
        "YYYY/MM/DD HH:mm:ss"
      );
      if (
        formattedStartDate.isValid() &&
        new Date(value) <= formattedStartDate.toDate()
      ) {
        return false;
      }
      if (
        formattedendDate.isValid() &&
        new Date(value) >= formattedendDate.toDate()
      ) {
        return false;
      }
      return true;
    },

    disasterNameFilter(value) {
      this.resetPage();
      if (!this.disasterNameFilterValue) {
        return true;
      }
      return value === this.disasterNameFilterValue;
    },

    emergencyClassFilter(value) {
      this.resetPage();
      if (
        !this.emergencyClassFilterValue ||
        this.emergencyClassFilterValue.length === 0
      ) {
        return true;
      }
      return this.emergencyClassFilterValue.includes(value);
    },

    orderStatusFilter(value) {
      this.resetPage();
      if (
        !this.orderStatusFilterValue ||
        this.orderStatusFilterValue.length === 0
      ) {
        return true;
      }
      return this.orderStatusFilterValue.includes(value + "");
    },

    municipCodeFilter(value) {
      this.resetPage();
      if (
        !this.municipCodeFilterList ||
        this.municipCodeFilterList.length == 0
      ) {
        return true;
      }
      let municipFlag = false;
      this.municipCodeFilterList.forEach(municipCode => {
        if (value.includes(municipCode)) {
          municipFlag = true;
        }
      });
      return municipFlag;
    },

    organizeIdFilter(value) {
      this.resetPage();
      if (!this.organizeIdFilterList || this.organizeIdFilterList.length == 0) {
        return true;
      }
      let organizeFlag = false;
      this.organizeIdFilterList.forEach(municipCode => {
        if (value.includes(municipCode)) {
          organizeFlag = true;
        }
      });
      return organizeFlag;
    },

    // 1ページ目に戻す処理
    resetPage() {
      if (this.$refs.disasterDeliveryTable) {
        this.$refs.disasterDeliveryTable.resetPage();
      }
    },

    async reload() {
      this.overlay = true;
      await deliveryRepository
        .list(this.screenId)
        .then(response => {
          this.disasterDeliverys = response.data.results;
        })
        .catch(e => {
          this.handleGetError(e);
        });
      this.overlay = false;
    },

    emergencyClassSorter(a, b) {
      if (a !== b) {
        // 配列の格納順でソート
        const sortList = [
          EmergencyClass.NL,
          EmergencyClass.AL,
          EmergencyClass.SE,
          EmergencyClass.GE,
          EmergencyClass.FN
        ];
        const indexA = sortList.indexOf(a);
        const indexB = sortList.indexOf(b);
        if (indexA > indexB) {
          return 1;
        } else {
          return -1;
        }
      }
      return 0;
    }
  }
};
</script>
